import { render, staticRenderFns } from "./BillKm.vue?vue&type=template&id=60d82ce4&scoped=true"
import script from "./BillKm.vue?vue&type=script&lang=js"
export * from "./BillKm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d82ce4",
  null
  
)

export default component.exports